import gql from "graphql-tag";
import { client } from '../constants/GraphQLClient';

async function fetchFAQData(text) {
    let search=(text!==""?`,search:"${text}"`:"");
    return client.query({
      query: gql`
        {
          fAQs(last:1000,where:{status:PUBLISH ${search}}) {
            edges {
              node {
                id
                title
                content
                faq_categories {
                  edges {
                    node {
                      faq_categoryId
                      name
                      slug
                    }
                  }
                }
              }
            }
          }
        }
      `,
      fetchPolicy:'network-only'
    })
}

async function fetchGeneralData() {
    return client.query({
      query: gql`
      query GET_DEFAULTS {
        tags (last:10000,where:{hideEmpty:false}) {
          edges {
            node {
              tagId
              name
              slug
            }
          }
        }
        countries (last:10000,where:{hideEmpty:false}) {
          edges {
            node {
              termTaxonomyId
              name
              slug
            }
          }
        }
        bMOs (last:10000,where:{hideEmpty:false}) {
          edges {
            node {
              termTaxonomyId
              name
              slug
              is_active
            }
          }
        }
        industries (last:10000,where:{hideEmpty:false}) {
          edges {
            node {
              termTaxonomyId
              industryId
              name
              slug
            }
          }
        }
        allSettings {
          generalSettingsTimezone
          ba_settingsSettingsBaDashboardDomain
        }
        banners {
          edges {
            node {
              title
              content
              banner_link
              featuredImage {
                id
                mediaDetails {
                  file
                  sizes {
                    file
                    height
                    mimeType
                    name
                    sourceUrl
                    width
                  }
                }
              }
            }
          }
        }
        pages(where:{title:"homepage"}) {
          edges {
            node {
              uri
              slug
              title
              content
            }
          }
        }
        faq_categories {
          edges {
            node {
              faq_categoryId
              name
              slug
            }
          }
        }
               
      }`,
      fetchPolicy:'network-only'
    })
  }
  
  async function contactUs(token,formdata) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/contact-us`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(formdata)
    });
  }

export default {
    fetchGeneralData,
    fetchFAQData,
    contactUs
};